import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'

interface UpdateParams {
  update: any
}

export function useNewApuracao() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ update }: UpdateParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        id_client: update.id_client || '',
        id_product: update?.id_product || '',
        id_tenant: update.id_tenant || '',
        typeServico: update?.typeServico || ''
      }

      const response = await api.post(`/apuracao`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao atualizar apuracao')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apuracao'] })
    }
  })
}
